import React, { forwardRef } from 'react';

import { StyledTab } from './styles';

export interface TabProps extends React.HTMLAttributes<HTMLButtonElement> {
  id: string;
  label: string;
  selected?: boolean;
  variant?: 'line' | 'point';
}

const Tab: React.FC<TabProps> = forwardRef<HTMLButtonElement, TabProps>(
  ({ label, selected, id, variant, ...props }, ref) => {
    return (
      <StyledTab
        role="tab"
        aria-selected={selected ? 'true' : 'false'}
        aria-controls={`panel-${id}`}
        selected={selected}
        id={`tab-${id}`}
        variant={variant}
        {...props}
        ref={ref}
      >
        {label}
      </StyledTab>
    );
  }
);

export default Tab;
